import React, {Component} from 'react';
import LoginForm from './LoginForm';
import MSignForm from './MSignForm';
import SmartIdForm from './SmartIdForm';
import {Redirect} from "react-router";
import {withTranslation} from "react-i18next";
import ErrorAlert from "../../../components/UI/ErrorAlert";
import AppContext from "../../../contexts/AppContext";
import Header from "../../ProcessSteps/Parts/Header";

class Login extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            is_permanent_redirect: true,
            login_method: "smartid",
        };

        this.chooseLogInByEmail = this.chooseLogInByEmail.bind(this);
        this.chooseLogInMSign = this.chooseLogInMSign.bind(this);
        this.chooseLogInSmartId = this.chooseLogInSmartId.bind(this);
    }

    chooseLogInByEmail() {
        const {clearError} = this.context;
        clearError();

        this.setState({login_method: "email"})
    }

    chooseLogInMSign() {
        const {clearError} = this.context;
        clearError();

        this.setState({login_method: "msign"})
    }

    chooseLogInSmartId() {
        const {clearError} = this.context;
        clearError();

        this.setState({login_method: "smartid"})
    }

    render(props) {
        if (this.state.is_permanent_redirect) {
            window.location.href = "https://inbank.lt/ident/prisijungti";
            return null;
        }

        if (this.props.is_logged_in) {
            return (<Redirect push={true} to="/dashboard"/>)
        }

        return (
            <div>
                <Header title={this.props.t('please_login')}/>

                <section>
                    <div className="container mt--5 mb-5">
                        <div className="row">
                            <div className="col-12">
                                <div className="frame">
                                    <div className="tabs">

                                        <ul role="tablist" className="nav nav-tabs justify-content-center">
                                            <li className="nav-item">
                                                <a
                                                    role="tab"
                                                    aria-selected="true"
                                                    href="#via-smartid"
                                                    aria-controls="via-smartid"
                                                    id="via-smartid-tab"
                                                    data-toggle="tab"
                                                    className="nav-link active"
                                                    tabIndex="-1"
                                                    onClick={this.chooseLogInSmartId}
                                                >{this.props.t('forms.via_smartid')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    role="tab"
                                                    aria-selected="true"
                                                    href="#via-msign"
                                                    aria-controls="via-msign"
                                                    id="via-msign-tab"
                                                    data-toggle="tab"
                                                    className="nav-link"
                                                    tabIndex="-1"
                                                    onClick={this.chooseLogInMSign}
                                                >{this.props.t('forms.via_msign')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    role="tab"
                                                    aria-selected="false"
                                                    href="#via-email"
                                                    aria-controls="via-email"
                                                    id="via-email-tab"
                                                    data-toggle="tab"
                                                    className="nav-link"
                                                    tabIndex="-1"
                                                    onClick={this.chooseLogInByEmail}
                                                >{this.props.t('forms.via_email')}</a>
                                            </li>
                                        </ul>

                                        <div className="col-12">
                                            <ErrorAlert/>
                                        </div>

                                        <div className="tab-content p-3 p-sm-5">
                                            <div
                                                role="tabpanel"
                                                className="tab-pane show active"
                                                id="via-smartid"
                                                aria-labelledby="via-smartid-tab"
                                            >
                                                <div className="container">
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-6 col-lg-4">
                                                            {this.state.login_method === "smartid" && (
                                                                <SmartIdForm
                                                                    is_logged_in={this.props.is_logged_in}
                                                                    mark_as_logged_in={this.props.mark_as_logged_in}
                                                                />)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                role="tabpanel"
                                                className="tab-pane"
                                                id="via-msign"
                                                aria-labelledby="via-msign-tab"
                                            >
                                                <div className="container">
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-6 col-lg-4">
                                                            {this.state.login_method === "msign" && (
                                                                <MSignForm
                                                                    is_logged_in={this.props.is_logged_in}
                                                                    mark_as_logged_in={this.props.mark_as_logged_in}
                                                                />)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                role="tabpanel"
                                                className="tab-pane"
                                                id="via-email"
                                                aria-labelledby="via-email-tab"
                                            >
                                                <div className="container">
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-6 col-lg-4">
                                                            {this.state.login_method === "email" &&
                                                            <LoginForm {...props}
                                                                       mark_as_logged_in={this.props.mark_as_logged_in}/>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default withTranslation()(Login);
